import React from 'react';

export const MCSALinkedinVortex = () => {
    return (
        <iframe
            title="LinkedIn Vortex"
            src="/mcsa_htmls__TBD/linkedin_vortex.html"
            style={{
                position: 'fixed',
                inset: 0,
                width: '100%',
                height: '100%',
                border: 'none',
            }}
        />
    );
};
